module.exports = __webpack_public_path__ + "img/sample.83157a4b.png";